import React from 'react';
import skill from '../../../img/Icons/Update/Skills.png'
import IconLarge from '../../GeneralSubcomponents/IconLarge'
import '../../../Styles/skills.css'
import skills from './skills.json'
import Skill from './Skill'

const Skills = () => {
    const skillMap = skills.reduce((accumulator, item) => {
        accumulator[item.nameSkill] = item;
        return accumulator;
    }, {});

    const skillGroups = [
        {
            title: 'Frontend Core',
            items: ['HTML', 'CSS', 'JavaScript', 'TypeScript', 'React', 'Next.js'],
        },
        {
            title: 'Styling & UI',
            items: ['SASS', 'Tailwind', 'Figma'],
        },
        {
            title: 'Testing & Quality',
            items: ['Cypress', 'Playwright', 'Jest'],
        },
        {
            title: 'Systems & Development',
            items: ['Node.js', 'Firebase', 'Git', 'GitHub', 'Cloudflare', 'Astro'],
        },
        {
            title: 'Analytics & Growth',
            items: ['GA4', 'GTM', 'Umami', 'SEMrush'],
        },
        {
            title: 'Marketing & CMS',
            items: ['Pardot', 'Salesforce', 'Storyblok'],
        },
    ];

    const automationDirection = [
        'APIs',
        'Webhooks',
        'Workflow Automation',
        'Lead Generation',
        'Conversion Optimization (CRO)',
        'Analytics Implementation',
        'Prompt Engineering',
        'AI-assisted workflows',
    ];

    return (
        <div className="skill">
            <div className="row o-icon-title"><IconLarge iconL={skill} /><p> &nbsp; Skills</p></div>
            <p className="o-skills-intro">
                Technologies and tools I use across development, systems, analytics, and growth-focused implementation.
            </p>
            {skillGroups.map((group) => (
                <div className="o-skill-group" key={group.title}>
                    <h3 className="o-skill-group-title">{group.title}</h3>
                    <div className="row d-flex justify-content-center align-content-center">
                        {group.items.map((itemName) => (
                            skillMap[itemName] ? (
                                <Skill
                                    key={itemName}
                                    imgSkill={skillMap[itemName].imgSkill}
                                    nameSkill={skillMap[itemName].nameSkill}
                                ></Skill>
                            ) : null
                        ))}
                    </div>
                </div>
            ))}
            <div className="o-skill-group">
                <h3 className="o-skill-group-title">Automation & GTM Direction</h3>
                <div className="o-skill-tags">
                    {automationDirection.map((item) => (
                        <span className="o-skill-tag" key={item}>{item}</span>
                    ))}
                </div>
            </div>
        </div>
    );
};
export default Skills;